import React, { useState, useEffect, useRef } from "react";
import Footer from "../Footer/Footer";
import NewHeader from "../NewHeader/NewHeader";
import SubFooter from "../SubFooter/SubFooter";
import LoginCarousel from "./LoginCarousel"
import ScrolltoTop from "../Scrolltotop/ScrolltoTop";
import { FaEye } from 'react-icons/fa';
import { FaEyeSlash } from 'react-icons/fa';
import "./Login.css";
import google from "../../Assets/google.png";
import facebook from "../../Assets/facebook.png";

function PasswordChange(){
  	const [disable, setDisable] = useState(false);
  	const [phoneNumber, setPhoneNumber] = useState("");
  	const [password1, setPassword1] = useState("");
  	const [password2, setPassword2] = useState("");
  	const [password1Shown, setPassword1Shown] = useState(false);
  	const [passwordEye1Shown, setPasswordEye1Shown] = useState(false);
  	const [password2Shown, setPassword2Shown] = useState(false);
  	const [passwordEye2Shown, setPasswordEye2Shown] = useState(false);
  	const [MobileErr, setMobileErr] = useState("");

	const ChangePasswordSubmit = (e) => {

	}
	
	const handlePassword1Change = (e) => {
		setPassword1(e.target.value);
	}
	const handlePassword2Change = (e) => {
		setPassword2(e.target.value);
	}
	const handlePassword1Show = () => {
		setPassword1Shown(!password1Shown);
		setPasswordEye1Shown(!passwordEye1Shown)
	}
	const handlePassword2Show = () => {
		setPassword2Shown(!password2Shown);
		setPasswordEye2Shown(!passwordEye2Shown)
	}
	return(
		<>
      		<NewHeader />
      		<div className="loginMainHeading">
		        <h1>Welcome To Redcliffe Labs! </h1>
		    </div>
      		<div className="loginNewContent">
      			<div className="loginNewFormDiv">
      				<div className="CarouselDivOfLogin">
      					<LoginCarousel />
      				</div>
      				<form
			            className="changePassword-form login-form"
			            onSubmit={ChangePasswordSubmit}
			        >
			            <p className="Loginpara">New Password</p>
			            <div className="PasswordInputAdd PasswordChngDiv">
				            <input
				            	type={password1Shown ? "text" : "password"}
				              	onChange={handlePassword1Change}
				              	value={password1}
				              	placeholder="Enter New Password"
				              	required
				              	className="password-field"

				            ></input>
				            {passwordEye1Shown ?
				            <FaEye className="passwordEyes" onClick={handlePassword1Show} />
				            :
				            <FaEyeSlash className="passwordEyes" onClick={handlePassword1Show} />
				        	}
				        </div>
			            <p className="Loginpara">Confirm Password</p>
			            <div className="PasswordInputAdd">
				            <input
				            	type={password2Shown ? "text" : "password"}
				              	onChange={handlePassword2Change}
				              	value={password2}
				              	placeholder="Enter Confirm Password"
				              	required
				              	className="password-field"

				            ></input>
				            {passwordEye2Shown ?
				            <FaEye className="passwordEyes" onClick={handlePassword2Show} />
				            :
				            <FaEyeSlash className="passwordEyes" onClick={handlePassword2Show} />
				        	}
				        </div>
			            <button
			              disabled={disable}
			              className="changePasswordbtn"
			            >
			              <span className="btn">Continue</span>
			            </button>
			        </form>
      			</div>
      		</div>
      		<Footer />
		</>
	)
}

export default {
  component: PasswordChange,
};
